import { HttpClient } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { EnvironmentToken } from '../../app.config';
import { Psa, StorePsaPayload, UpdatePsaPayload } from '../models/psa.model';

export class PsaService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;
  #isLoading = signal<Set<unknown>>(new Set());

  #psas = new BehaviorSubject<Psa[]>([]);

  public psas$ = this.#psas.asObservable();
  public psas = toSignal(this.psas$, {
    initialValue: [],
  });

  getPsas() {
    this.#execute(
      this.#http.get<Psa[]>(`${this.#apiUrl}/api/psas`),
    ).subscribe({
      next: (psas: any) => {
        this.#psas.next(psas.data ?? psas);
      },
      error: (e: any) => console.log(e),
    });
  }

  createPsa(data: StorePsaPayload) {
    return this.#execute(
      this.#http.post<Psa>(`${this.#apiUrl}/api/psas`, data),
    );
  }

  updatePsa(id: string, data: UpdatePsaPayload) {
    return this.#execute(
      this.#http.put<Psa>(`${this.#apiUrl}/api/psas/${id}`, data),
    );
  }

  deletePsa(id: string) {
    return this.#execute(
      this.#http.delete(`${this.#apiUrl}/api/psas/${id}`),
    );
  }

  #execute<T = unknown>(apiCall: Observable<T>) {
    this.#isLoading.update((x) => {
      x.add(apiCall);
      return new Set(x.values());
    });
    return apiCall.pipe(
      finalize(() =>
        this.#isLoading.update((x) => {
          x.delete(apiCall);
          return new Set(x.values());
        }),
      ),
    );
  }
}
